import { render } from "./ExpertReviewListing.vue?vue&type=template&id=353e5d76&ts=true"
import script from "./ExpertReviewListing.vue?vue&type=script&lang=ts"
export * from "./ExpertReviewListing.vue?vue&type=script&lang=ts"

import "./expert-review.scss?vue&type=style&index=0&lang=scss"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__